import { gql } from "@apollo/client";

export const SET_SPACE_MEMBERSHIP = gql`
  mutation SetSpaceMembership($input: SetSpaceMembershipInput!) {
    setSpaceMembership(input: $input)
  }
`;
